/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_DigirealityInputs */

const cs_enum_digireality = /** @type {(inputs: Enum_DigirealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digireality`)
};

const en_enum_digireality = /** @type {(inputs: Enum_DigirealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digireality`)
};

/**
* | output |
* | --- |
* | "Digireality" |
*
* @param {Enum_DigirealityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_digireality = /** @type {((inputs?: Enum_DigirealityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_DigirealityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_digireality(inputs)
	return cs_enum_digireality(inputs)
});